import React, { Component } from "react";
import { Table, Form, Input, Button } from "antd";
import { UnorderedListOutlined } from "@ant-design/icons";
import moment from "moment";
import { TotalRow } from "./total-row";
import {
  columns,
  formValidate,
  initFormValue,
  enableEdit,
  convertCosts,
  handleSubmitValue,
  enableEditFolowWeb,
  enableEditFolowWebSelfDrive,
  kmDependencies,
  enableEditFolowKmEnd,
  enableEditFolowKmStart,
  enableEditFolowNote,
  enableEditFolowKmStartEnd,
} from "./table-data";
import { driverlessColumns } from "./driverless/table-data-driverless";
import { InputNumber } from "../../../../components/common/input-number";
import { TimeRange } from "./time-range";
import { ShortInfo } from "./short-info";
import { DriverlessShortInfo } from "./driverless-short-info";
import { apiJourney } from "../../../../api/api-journey";
import { emitter } from "../../../../common/utils/emitter";
import { alert } from "../../../../common/utils/alert";
import { dateFormatVi } from "../../../../common/utils/static-data";
import { CheckBoxForm } from "./checkbox-form";
import { FlagNote } from "./flag-note";
import {
  columns as columnsPayment,
  columnsDriverless,
} from "../../customer/payment-request/data-table";

moment.locale("vn");

export class JourneyDiary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contractDataDetail: {},
      isShowTitle: true,
      buttonDisable: false,
      editingKey: "",
      is_self_drive: false,
      data: [],
      date: {
        start: moment().startOf("month").startOf("day").valueOf(),
        end: moment().endOf("day").valueOf(),
      },
      xScroll: window.innerHeight <= 800 ? 400 : window.innerHeight - 450,
      laybelData: {
        contract_working_days: 0,
        real_working_days: 0,
      },
      working_day: { code: "" },
      total: {
        over_km: 0,
        // km_traveled: 0,
      },
      member_customer_ids: "",
    };
    this.expandedRows = [];
  }

  async componentDidMount() {
    const start = moment().startOf("month").startOf("day").valueOf();
    const end = moment().endOf("day").valueOf();
    this.getData(start, end);
    window.addEventListener("resize", () => {
      if (window.innerHeight <= 800) {
        this.setState({ xScroll: 400 });
      } else {
        this.setState({ xScroll: window.innerHeight - 450 });
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => {});
  }

  onChangeDate = (start, end) => {
    this.setState({ editingKey: "" }, () => {
      this.setState({ date: { start, end } });
      this.getData(start, end);
    });
  };

  getData = async (start, end) => {
    const { member_customer_ids } = this.state;

    try {
      emitter.emit("FETCH_LOADING", true);
      const { contractData } = this.props;
      if (contractData.contract_type.id !== 2) {
        const journeyDiaryDetail = await apiJourney.getJourneyDiaryDetail({
          contract_id: contractData.id,
          from_date: start,
          to_date: end,
          member_customer_ids,
        });

        if (journeyDiaryDetail.status === "success") {
          const { data } = journeyDiaryDetail;
          this.setState(
            {
              contractDataDetail: {
                working_time_from: data.contract.working_time_from,
                working_time_to: data.contract.working_time_to,
                working_time_weekend_holiday_from:
                  data.contract.working_time_weekend_holiday_from,
                working_time_weekend_holiday_to:
                  data.contract.working_time_weekend_holiday_to,
                driver: data.contract.driver,
                vehicle: data.contract.vehicle,
                branch: data.contract.branch,
                vehicle_working_area: data.contract.vehicle_working_area,
              },
              editingKey: "",
              is_self_drive: false,
              working_day: data.contract.working_day,
              laybelData: data.date_statistic,
              total: data.total,
              data: data.journey_diary_dailies.map((value, index) => {
                return {
                  ...value,
                  ...convertCosts(value.costs ? value.costs : []),
                  key: index + 1,

                  children: value.children.reverse().map((chil, idx) => {
                    return {
                      ...chil,
                      ...convertCosts(chil.costs ? chil.costs : []),
                      key: `${index + 1}.${idx}`,
                      children: undefined,
                      app_work_time: [
                        chil.working_time_app_from,
                        chil.working_time_app_to,
                      ],
                      gps_work_time: [
                        chil.working_time_gps_from,
                        chil.working_time_gps_to,
                      ],
                    };
                  }),
                  index: index + 1,
                  week_day: dateFormatVi[moment(value.date).format("dddd")],
                  app_work_time: [
                    value.working_time_app_from,
                    value.working_time_app_to,
                  ],
                  gps_work_time: [
                    value.working_time_gps_from,
                    value.working_time_gps_to,
                  ],
                };
              }),
            },
            () => {
              emitter.emit("FETCH_LOADING", false);
            }
          );
        } else {
          emitter.emit("FETCH_LOADING", false);
        }
      } else {
        const journeyDiaryDetail = await apiJourney.getJourneyDiaryDetail({
          contract_id: contractData.id,
          from_date: start,
          to_date: end,
          member_customer_ids,
        });
        if (journeyDiaryDetail.status === "success") {
          const { data } = journeyDiaryDetail;

          this.setState(
            {
              editingKey: "",
              is_self_drive: false,
              working_day: data.working_day,
              laybelData: data.date_statistic,
              total: {
                over_km: data.total.over_km,
              },
              data: data.journey_diary_dailies.map((value, index) => {
                return {
                  ...value,
                  key: index + 1,

                  children: value.children.reverse().map((chil, idx) => {
                    return {
                      ...chil,
                      key: `${index + 1}.${idx}`,
                      children: undefined,
                    };
                  }),
                  index: index + 1,
                  week_day: dateFormatVi[moment(value.date).format("dddd")],
                };
              }),
            },
            () => {
              emitter.emit("FETCH_LOADING", false);
            }
          );
        } else {
          emitter.emit("FETCH_LOADING", false);
        }
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  onChangeEnableForm = (is_self_drive) => {
    const values = this.form.getFieldsValue();
    this.setState({ is_self_drive }, () => {
      this.form.setFieldsValue({
        is_self_drive: is_self_drive,
        is_with_driver: !is_self_drive,
      });
    });
    if (is_self_drive) {
      this.form.setFieldsValue({
        km_customer_get_in: values.km_start,
        km_customer_get_out: values.km_end,
      });
    } else {
      this.form.setFieldsValue({
        km_customer_get_in: 0,
        km_customer_get_out: 0,
        km_start: 0,
        km_end: 0,
      });
    }
  };

  autoFillKm = (is_km, value) => {
    if (is_km === "km_start") {
      this.form.setFieldsValue({
        km_customer_get_in: value,
      });
    }
    if (is_km === "km_end") {
      this.form.setFieldsValue({
        km_customer_get_out: value,
      });
    }
    if (is_km === "km_customer_get_in") {
      this.form.setFieldsValue({
        km_start: value,
      });
    }
    if (is_km === "km_customer_get_out") {
      this.form.setFieldsValue({
        km_end: value,
      });
    }
  };

  EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    is_money,
    record,
    isPercent,
    index,
    children,
    ...restProps
  }) => {
    let editable = true;
    let inputNode =
      inputType === "input-number" ? (
        <InputNumber
          autoFillKm={this.autoFillKm}
          is_km={dataIndex}
          is_self_drive={this.state.is_self_drive}
          is_money={is_money}
          percent={isPercent}
        />
      ) : (
        <Input />
      );
    if (inputType === "range-time") {
      inputNode = <TimeRange />;
    }

    if (dataIndex === "note") {
      inputNode = <Input.TextArea autoSize={{ maxRows: 2 }} />;
    }

    if (dataIndex === "overnight") {
      inputNode = <InputNumber maxNumber={1} />;
    }

    if (inputType === "checkbox") {
      inputNode = (
        <CheckBoxForm
          onChangeEnableForm={this.onChangeEnableForm}
          field={dataIndex}
        />
      );
    }
    const { contractData } = this.props;
    if (contractData.contract_type.id !== 2) {
      if (record && record.journey_diary_id) {
        editable = enableEdit(dataIndex);
      } else {
        const { is_self_drive } = this.state;
        if (is_self_drive) {
          editable = enableEditFolowWebSelfDrive(dataIndex);
        } else {
          editable = enableEditFolowWeb(dataIndex);
        }
      }
    } else {
      if (record && record.km_end && record.km_start) {
        editable = enableEditFolowKmStartEnd(dataIndex);
      } else if (record && record.km_end) {
        editable = enableEditFolowKmEnd(dataIndex);
      } else if (record && record.km_start) {
        editable = enableEditFolowKmStart(dataIndex);
      } else if (record && record.journey_diary_id) {
        editable = enableEditFolowNote(dataIndex);
      } else {
        editable = false;
      }
    }

    if (dataIndex === "is_weekend") {
      const { working_day } = this.state;
      if (working_day.code === "WD005") {
        editable = true;
      } else {
        editable = false;
      }
    }

    return (
      <td {...restProps}>
        {editing && editable ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            dependencies={kmDependencies}
            rules={formValidate(
              dataIndex,
              inputType,
              record,
              contractData.contract_type.id
            )}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  isEditing = (record) => {
    return record.key === this.state.editingKey;
  };

  edit = (record) => {
    this.form.setFieldsValue({
      ...initFormValue,
      ...record,
      km_start: record.km_start ? record.km_start : 0,
      km_customer_get_in:
        record.is_self_drive && !record.is_with_driver
          ? record.km_start
            ? record.km_start
            : 0
          : record.km_customer_get_in
          ? record.km_customer_get_in
          : 0,
      km_customer_get_out:
        record.is_self_drive && !record.is_with_driver
          ? record.km_end
            ? record.km_end
            : 0
          : record.km_customer_get_out
          ? record.km_customer_get_out
          : 0,
      km_end: record.km_end ? record.km_end : 0,
      overnight: record.overnight ? record.overnight : 0,
    });
    this.setState({
      editingKey: record.key,
      is_self_drive: record.is_self_drive ? record.is_self_drive : false,
    });
  };

  delete = async (record) => {
    try {
      if (
        record.km_start === undefined ||
        record.km_start === null ||
        !record.id
      ) {
        this.setState({ editingKey: "" }, () => {
          const { date } = this.state;
          this.getData(date.start, date.end);
        });
        return;
      }
      emitter.emit("FETCH_LOADING", true);
      const result = await apiJourney.deleteJourneyDiary(record.id);
      emitter.emit("FETCH_LOADING", false);
      if (result.status === "success") {
        const { date } = this.state;
        alert("success", "Xoá thành công");
        this.getData(date.start, date.end);
      } else {
        alert("error", "Dữ liệu không được phép xoá");
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  cancel = () => {
    this.setState({ editingKey: "" }, () => {
      const { date } = this.state;
      this.getData(date.start, date.end);
    });
  };

  apiCallSave = async (payload, isClickManual) => {
    let is_new = true;
    let flag_finished_modify = false;
    let api = apiJourney.createJourneyDiaryDaily;
    if (payload.id !== null && payload.id !== undefined) {
      is_new = false;
      flag_finished_modify = false;
    }

    if (payload.journey_diary_id) {
      api = apiJourney.editAppDiary;
    }

    if (isClickManual) {
      flag_finished_modify = payload.flag_finished_modify;
    }
    const { contractData } = this.props;

    if (contractData.contract_type.id === 1) {
      try {
        const result = await api({
          ...payload,
          is_new,
          contract_id: contractData.id,
          flag_finished_modify,
        });
        emitter.emit("FETCH_LOADING", false);
        this.setState({ buttonDisable: false });
        if (result.status === "success") {
          this.form && this.form.scrollToField("customer_name_used");
          alert("success", "Cập nhật thành công");
          const { date } = this.state;
          this.setState({ editingKey: "" });
          this.getData(date.start, date.end);
        } else {
          alert("error", result.data.message);
        }
      } catch (error) {
        this.setState({ buttonDisable: false });
        emitter.emit("FETCH_LOADING", false);
      }
    } else {
      try {
        const result = await apiJourney.updateDiaryDriverless({ ...payload });
        emitter.emit("FETCH_LOADING", false);
        this.setState({ buttonDisable: false });
        if (result.status === "success") {
          this.form && this.form.scrollToField("customer_name_used");
          alert("success", "Cập nhật thành công");
          const { date } = this.state;
          this.setState({ editingKey: "" });
          this.getData(date.start, date.end);
        } else {
          alert("error", result.data.message);
        }
      } catch (error) {
        this.setState({ buttonDisable: false });
        emitter.emit("FETCH_LOADING", false);
      }
    }
  };

  save = (record, isClickManual) => {
    this.setState({ buttonDisable: true }, async () => {
      try {
        emitter.emit("FETCH_LOADING", true);
        const row = await this.form.validateFields();
        const payloadData = handleSubmitValue(row ? row : {}, record);
        this.apiCallSave(payloadData, isClickManual);
      } catch (errInfo) {
        emitter.emit("FETCH_LOADING", false);
        this.setState({ buttonDisable: false });
        this.form.scrollToField("customer_name_used");
      }
    });
  };

  add = (record) => {
    const { data } = this.state;
    const { key } = record;
    this.setState(
      {
        is_self_drive: false,
        data: data.map((value) => {
          if (value.key === key) {
            if (value.children.length === 0) {
              return {
                ...value,
                children: [
                  {
                    ...initFormValue,
                    key: `${value.key}.2`,
                    week_day: "",
                    date: value.date,
                    app_work_time: [null, null],
                    gps_work_time: [null, null],
                    parentKey: key,
                    children: undefined,
                    is_weekend: value.is_weekend,
                    is_holiday: value.is_holiday,
                  },
                  {
                    ...value,
                    children: undefined,
                    week_day: "",
                    key: `${value.key}.1}`,
                    index: undefined,
                    parentKey: key,
                  },
                ],
              };
            }
            return {
              ...value,
              children: [
                {
                  ...initFormValue,
                  key: `${value.key}.${value.children.length + 1}`,
                  week_day: "",
                  date: value.date,
                  app_work_time: [null, null],
                  gps_work_time: [null, null],
                  children: undefined,
                  parentKey: key,
                  is_weekend: value.is_weekend,
                  is_holiday: value.is_holiday,
                  parent_id: value.id,
                },
              ].concat(value.children),
            };
          }
          return value;
        }),
      },
      () => {
        const { data } = this.state;
        const newRecordIndex = data.findIndex((value) => value.key === key);
        const newRecord =
          newRecordIndex !== -1 ? data[newRecordIndex] : data[0];
        this.edit(newRecord.children[0]);
        const checkExpand = this.expandedRows.findIndex(
          (value) => value === record.key
        );
        if (checkExpand === -1) {
          this.onExpand(record);
        }
      }
    );
  };

  mergedColumns = columns(this).map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col?.inputType,
        dataIndex: col.dataIndex,
        title: col.title,
        is_money: col?.is_money,
        isPercent: col?.isPercent,
        editing: this.isEditing(record),
      }),
    };
  });

  mergedDriveLessColumns = driverlessColumns(this).map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col?.inputType,
        dataIndex: col.dataIndex,
        title: col.title,
        is_money: col?.is_money,
        isPercent: col?.isPercent,
        editing: this.isEditing(record),
      }),
    };
  });

  handleShowTitle = () => {
    this.setState({ isShowTitle: !this.state.isShowTitle });
  };

  handleExportJourneyDiary = async () => {
    try {
      const { contractData } = this.props;
      const filter = {
        contract_id: contractData.id,
        from_date: this.state.date.start,
        to_date: this.state.date.end,
        member_customer_ids: this.state.member_customer_ids,
        ...(this.props.isCustomer && { type: "pdf" }),
      };
      emitter.emit("FETCH_LOADING", true);

      const func = this.props.isCustomer
        ? apiJourney.exportJourneyDiaryPdf
        : apiJourney.exportJourneyDiary;

      func(filter).then((res) => {
        if (res === "success") {
          alert("success", "Export thành công");
          emitter.emit("FETCH_LOADING", false);
        } else {
          alert("error", "Không export thành công");
          emitter.emit("FETCH_LOADING", false);
        }
      });
    } catch (error) {
      alert("error", "Không export thành công");
      emitter.emit("FETCH_LOADING", false);
    }
  };

  onChangeName = (name) => {
    if (this.props.updateNameFilterJorney) {
      this.props.updateNameFilterJorney(name);
    }
    this.setState({ member_customer_ids: name }, () => {
      this.getData(this.state.date.start, this.state.date.end);
    });
  };

  render() {
    const {
      data,
      date,
      xScroll,
      laybelData,
      total,
      isShowTitle,
      contractDataDetail,
    } = this.state;
    const { contractData } = this.props;

    return (
      <div className="journey-diary">
        <div className="title-diary">
          {" "}
          <UnorderedListOutlined
            style={{ fontSize: 15, fontWeight: "600" }}
            onClick={this.handleShowTitle}
          />{" "}
          {isShowTitle ? "Chọn thời gian xem NKHT:" : ""}
        </div>
        {isShowTitle && contractData.contract_type.id === 1 && (
          <ShortInfo
            onChangeName={this.onChangeName}
            laybelData={laybelData}
            onChangeDate={this.onChangeDate}
            contractData={contractData}
            contractDataDetail={contractDataDetail}
          />
        )}
        {isShowTitle && contractData.contract_type.id === 2 && (
          <DriverlessShortInfo
            laybelData={laybelData}
            onChangeDate={this.onChangeDate}
            contractData={contractData}
          />
        )}
        <Form
          scrollToFirstError
          initialValues={{
            app_work_time: [moment().subtract(1, "day"), moment()],
            gps_work_time: [moment().subtract(1, "day"), moment()],
          }}
          ref={(ref) => (this.form = ref)}
          component={false}
        >
          <Table
            id="journey-table-diary"
            className="diary-table"
            style={{ width: "100%" }}
            scroll={{ x: true, y: xScroll, scrollToFirstRowOnChange: true }}
            columns={
              this.props.isCustomer
                ? contractData.contract_type.id === 1
                  ? columnsPayment(this)
                  : columnsDriverless(this)
                : contractData.contract_type.id === 1
                ? this.mergedColumns
                : this.mergedDriveLessColumns
            }
            components={{
              body: {
                cell: this.EditableCell,
              },
            }}
            bordered
            summary={(pageData) => {
              return (
                <TotalRow
                  total={total}
                  pageData={pageData}
                  isCustomer={this.props.isCustomer}
                  isDriverLess={
                    contractData.contract_type.id === 1 ? false : true
                  }
                />
              );
            }}
            pagination={false}
            expandable={{
              onExpandedRowsChange: (expandedRows) => {
                this.expandedRows = expandedRows;
              },
              expandIcon: ({ expanded, onExpand, record, expandable }) => {
                this.onExpand = onExpand;
                return expandable && (expanded ? null : null);
              },
            }}
            dataSource={data}
          />
        </Form>

        {contractData.contract_type.id === 1 && !this.props.isCustomer ? (
          <FlagNote />
        ) : null}

        <div className="button-container">
          {!this.props.isCustomer && (
            <Button
              onClick={() =>
                this.props.goToPaymentRequest(true, data, date, total)
              }
              className="add-btn journey-button"
            >
              Payment Request
            </Button>
          )}
          <Button
            onClick={this.handleExportJourneyDiary}
            className="export-btn"
          >
            Export
          </Button>
        </div>
      </div>
    );
  }
}
